import apiStore from './index';
import { paths } from '@src/consts/apiPaths';
import { getFormData } from './utils';
import analytics from '@src/firebase/analytics';

const logger = Logger.get('apis/profile');

const getProfilePath = (subID = '') => `/subscriber/${subID + paths.profiles}`;

const requestAddProfile = async (payload = {}) => {
  const { subscriberId, ...data } = payload;

  const formData = getFormData(data);

  const path = getProfilePath(subscriberId);

  const { data: body } = await apiStore.axios.post(path, formData);

  return body;
};

const fetchProfiles = async (payload = {}) => {
  try {
    const { subscriberId } = payload;

    const path = getProfilePath(subscriberId);

    let { data: body } = await apiStore.axios.get(path);

    if (!body.totalcount) throw new Error('no profiles');

    return body.data;
  } catch (error) {
    logger.log(error);
    return [];
  }
};

const requestUpdate = async (payload = {}, commonAnalytics) => {
  const { subscriberId, profileid, ...data } = payload;

  try{
  const path = `/subscriber/${ subscriberId }/profile/${ profileid }`;

  const { data: body } = await apiStore.axios.put(path, { ...data });

  if ( body.error === 1057  ) return {} ; //nothing to update.

  if( !body.success ) throw body;

  analytics.logEvent( 'ADDEDITPROFILE', { ...commonAnalytics, ...{ Mode:'EDIT' , Status : 'SUCCESS', DOB:payload.dob, Gender:payload.gender, City:payload.city, State:payload.state, Country:payload.country  }} );

  return {...data , profileid};
  }
  catch(error) {
    analytics.logEvent( 'ADDEDITPROFILE', { ...commonAnalytics, ...{ Mode:'EDIT',ErrorMessage: error.reason, ErrorCode: error.code} } )
    throw error;
  }
};

export { requestAddProfile, fetchProfiles, requestUpdate };
